/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Additional } from './Additional';
import {
    AdditionalFromJSON,
    AdditionalFromJSONTyped,
    AdditionalToJSON,
} from './Additional';
import type { EnterprisePrice } from './EnterprisePrice';
import {
    EnterprisePriceFromJSON,
    EnterprisePriceFromJSONTyped,
    EnterprisePriceToJSON,
} from './EnterprisePrice';
import type { GraduatedPrice } from './GraduatedPrice';
import {
    GraduatedPriceFromJSON,
    GraduatedPriceFromJSONTyped,
    GraduatedPriceToJSON,
} from './GraduatedPrice';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
} from './Pricing';
import type { ProductCategory } from './ProductCategory';
import {
    ProductCategoryFromJSON,
    ProductCategoryFromJSONTyped,
    ProductCategoryToJSON,
} from './ProductCategory';
import type { ProductType } from './ProductType';
import {
    ProductTypeFromJSON,
    ProductTypeFromJSONTyped,
    ProductTypeToJSON,
} from './ProductType';
import type { SpecificActiveProduct } from './SpecificActiveProduct';
import {
    SpecificActiveProductFromJSON,
    SpecificActiveProductFromJSONTyped,
    SpecificActiveProductToJSON,
} from './SpecificActiveProduct';
import type { SpecificCustomer } from './SpecificCustomer';
import {
    SpecificCustomerFromJSON,
    SpecificCustomerFromJSONTyped,
    SpecificCustomerToJSON,
} from './SpecificCustomer';
import type { SpecificOrganisation } from './SpecificOrganisation';
import {
    SpecificOrganisationFromJSON,
    SpecificOrganisationFromJSONTyped,
    SpecificOrganisationToJSON,
} from './SpecificOrganisation';
import type { SubscriptionDetails } from './SubscriptionDetails';
import {
    SubscriptionDetailsFromJSON,
    SubscriptionDetailsFromJSONTyped,
    SubscriptionDetailsToJSON,
} from './SubscriptionDetails';
import type { TenantProductDetails } from './TenantProductDetails';
import {
    TenantProductDetailsFromJSON,
    TenantProductDetailsFromJSONTyped,
    TenantProductDetailsToJSON,
} from './TenantProductDetails';
import type { ThresholdPrice } from './ThresholdPrice';
import {
    ThresholdPriceFromJSON,
    ThresholdPriceFromJSONTyped,
    ThresholdPriceToJSON,
} from './ThresholdPrice';
import type { Unit } from './Unit';
import {
    UnitFromJSON,
    UnitFromJSONTyped,
    UnitToJSON,
} from './Unit';

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    canonicalId?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    orderNr?: number;
    /**
     * product display name
     * @type {string}
     * @memberof Product
     */
    name?: string;
    /**
     * product description
     * @type {string}
     * @memberof Product
     */
    description?: string;
    /**
     * product quantity description
     * @type {string}
     * @memberof Product
     */
    quantityDescription?: string;
    /**
     * 
     * @type {ProductCategory}
     * @memberof Product
     */
    productCategory?: ProductCategory;
    /**
     * 
     * @type {SubscriptionDetails}
     * @memberof Product
     */
    subscriptionDetails?: SubscriptionDetails;
    /**
     * 
     * @type {TenantProductDetails}
     * @memberof Product
     */
    tenantDetails?: TenantProductDetails;
    /**
     * 
     * @type {ProductType}
     * @memberof Product
     */
    productType?: ProductType;
    /**
     * 
     * @type {Pricing}
     * @memberof Product
     */
    pricing?: Pricing;
    /**
     * 
     * @type {Price}
     * @memberof Product
     */
    price?: Price;
    /**
     * 
     * @type {Array<ThresholdPrice>}
     * @memberof Product
     */
    thresholdPrices?: Array<ThresholdPrice>;
    /**
     * 
     * @type {Array<GraduatedPrice>}
     * @memberof Product
     */
    graduatedPrices?: Array<GraduatedPrice>;
    /**
     * 
     * @type {EnterprisePrice}
     * @memberof Product
     */
    enterprisePrice?: EnterprisePrice;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    fixedQuantity?: boolean;
    /**
     * 
     * @type {Array<Additional>}
     * @memberof Product
     */
    additionals?: Array<Additional>;
    /**
     * 
     * @type {Unit}
     * @memberof Product
     */
    unit?: Unit;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    availableToPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    readonly disabled?: boolean;
    /**
     * 
     * @type {Array<SpecificCustomer>}
     * @memberof Product
     */
    specificCustomers?: Array<SpecificCustomer>;
    /**
     * 
     * @type {Array<SpecificOrganisation>}
     * @memberof Product
     */
    specificOrganisations?: Array<SpecificOrganisation>;
    /**
     * 
     * @type {Array<SpecificActiveProduct>}
     * @memberof Product
     */
    specificActiveProducts?: Array<SpecificActiveProduct>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productImageId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    storeAvailability?: boolean;
}

/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'canonicalId': !exists(json, 'canonicalId') ? undefined : json['canonicalId'],
        'orderNr': !exists(json, 'orderNr') ? undefined : json['orderNr'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantityDescription': !exists(json, 'quantityDescription') ? undefined : json['quantityDescription'],
        'productCategory': !exists(json, 'productCategory') ? undefined : ProductCategoryFromJSON(json['productCategory']),
        'subscriptionDetails': !exists(json, 'subscriptionDetails') ? undefined : SubscriptionDetailsFromJSON(json['subscriptionDetails']),
        'tenantDetails': !exists(json, 'tenantDetails') ? undefined : TenantProductDetailsFromJSON(json['tenantDetails']),
        'productType': !exists(json, 'productType') ? undefined : ProductTypeFromJSON(json['productType']),
        'pricing': !exists(json, 'pricing') ? undefined : PricingFromJSON(json['pricing']),
        'price': !exists(json, 'price') ? undefined : PriceFromJSON(json['price']),
        'thresholdPrices': !exists(json, 'thresholdPrices') ? undefined : ((json['thresholdPrices'] as Array<any>).map(ThresholdPriceFromJSON)),
        'graduatedPrices': !exists(json, 'graduatedPrices') ? undefined : ((json['graduatedPrices'] as Array<any>).map(GraduatedPriceFromJSON)),
        'enterprisePrice': !exists(json, 'enterprisePrice') ? undefined : EnterprisePriceFromJSON(json['enterprisePrice']),
        'fixedQuantity': !exists(json, 'fixedQuantity') ? undefined : json['fixedQuantity'],
        'additionals': !exists(json, 'additionals') ? undefined : ((json['additionals'] as Array<any>).map(AdditionalFromJSON)),
        'unit': !exists(json, 'unit') ? undefined : UnitFromJSON(json['unit']),
        'availableToPublic': !exists(json, 'availableToPublic') ? undefined : json['availableToPublic'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'specificCustomers': !exists(json, 'specificCustomers') ? undefined : ((json['specificCustomers'] as Array<any>).map(SpecificCustomerFromJSON)),
        'specificOrganisations': !exists(json, 'specificOrganisations') ? undefined : ((json['specificOrganisations'] as Array<any>).map(SpecificOrganisationFromJSON)),
        'specificActiveProducts': !exists(json, 'specificActiveProducts') ? undefined : ((json['specificActiveProducts'] as Array<any>).map(SpecificActiveProductFromJSON)),
        'productImageId': !exists(json, 'productImageId') ? undefined : json['productImageId'],
        'storeAvailability': !exists(json, 'storeAvailability') ? undefined : json['storeAvailability'],
    };
}

export function ProductToJSON(value?: Product | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'canonicalId': value.canonicalId,
        'orderNr': value.orderNr,
        'name': value.name,
        'description': value.description,
        'quantityDescription': value.quantityDescription,
        'productCategory': ProductCategoryToJSON(value.productCategory),
        'subscriptionDetails': SubscriptionDetailsToJSON(value.subscriptionDetails),
        'tenantDetails': TenantProductDetailsToJSON(value.tenantDetails),
        'productType': ProductTypeToJSON(value.productType),
        'pricing': PricingToJSON(value.pricing),
        'price': PriceToJSON(value.price),
        'thresholdPrices': value.thresholdPrices === undefined ? undefined : ((value.thresholdPrices as Array<any>).map(ThresholdPriceToJSON)),
        'graduatedPrices': value.graduatedPrices === undefined ? undefined : ((value.graduatedPrices as Array<any>).map(GraduatedPriceToJSON)),
        'enterprisePrice': EnterprisePriceToJSON(value.enterprisePrice),
        'fixedQuantity': value.fixedQuantity,
        'additionals': value.additionals === undefined ? undefined : ((value.additionals as Array<any>).map(AdditionalToJSON)),
        'unit': UnitToJSON(value.unit),
        'availableToPublic': value.availableToPublic,
        'specificCustomers': value.specificCustomers === undefined ? undefined : ((value.specificCustomers as Array<any>).map(SpecificCustomerToJSON)),
        'specificOrganisations': value.specificOrganisations === undefined ? undefined : ((value.specificOrganisations as Array<any>).map(SpecificOrganisationToJSON)),
        'specificActiveProducts': value.specificActiveProducts === undefined ? undefined : ((value.specificActiveProducts as Array<any>).map(SpecificActiveProductToJSON)),
        'productImageId': value.productImageId,
        'storeAvailability': value.storeAvailability,
    };
}

